module.exports = __webpack_public_path__ + "img/bank_card.32066ee2.png";